import { render, staticRenderFns } from "./IconWithDetailToTop.vue?vue&type=template&id=4bf77126&scoped=true&"
import script from "./IconWithDetailToTop.vue?vue&type=script&lang=js&"
export * from "./IconWithDetailToTop.vue?vue&type=script&lang=js&"
import style0 from "./IconWithDetailToTop.vue?vue&type=style&index=0&id=4bf77126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf77126",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AsyncObjectSnippetTooltip: require('/web/components/AsyncObjectSnippetTooltip.vue').default})
